import { TOGGLE_VM_EXTEND } from "../actions/UIActions";

const initialState = {
    isVMExtended: false,
};

const layoutReducer = (state = initialState, action) => {
    switch (action.type) {
        case TOGGLE_VM_EXTEND:
            return {
                ...state,
                isVMExtended: action.payload,
            };
        default:
            return state;
    }
};

export default layoutReducer; 